<template>
    <div class="paging clearfix">
        <div class="page-size fl" v-if="isShowTotal">共{{total}}条</div>
        <div class="page-jump fl" v-if="isShowJumper">
            <select class="select" v-model="toPage" @change="changePage(toPage)">
                <option v-for="p in totalPage" :key="p" :value="p">{{p}}</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Paging',
  // props:[
  //    'name'
  // ],
  // prop验证
  props:{
    name:String,
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    layout:{
        type: String
    }
  },
  data () {
    return {
            isShowJumper:false,
            isShowTotal:false,
            toPage:'',//跳转到x页
            pageGroup:5//可见分页数量 默认10个分页数
    }
  },
  created: function () {
        console.log('created');
        this.isShowTotal = this.layout.indexOf('total')!==-1;
        this.isShowJumper = this.layout.indexOf('jumper')!==-1;
        this.toPage = this.currentPage;
    },
    mounted: function () {
        console.log('mounted',this.layout);
    },
    watch: {
        currentPage: function(val) {
            this.toPage = val;
        }
    },
    computed:{
        totalPage:function(){
            return Math.ceil(this.total / this.pageSize)
        },
        pagelist:function(){
            var list = [];
            var count = Math.floor(this.pageGroup/2), center = this.currentPage;
            var left = 1,right = this.totalPage;

            if(this.totalPage>this.pageGroup){
                if(this.currentPage>count+1){
                    if(this.currentPage < this.totalPage - count){
                        left = this.currentPage - count;
                        right = this.currentPage + count-1;
                    }else{
                        left = this.totalPage - this.pageGroup+1;
                    }
                }else{
                    right = this.pageGroup;
                }
            }

            // 遍历添加到数组里
            while(left<=right){
                list.push({
                    text:left,
                    val:left
                });
                left++;
            }
            return list;
        }
    },
  methods:{
    // 回车事件
    submit(toPage,e){
        // console.log('e.keyCode',toPage,e.keyCode)
        // key.Code === 13表示回车键 
        if(e.keyCode === 13){
            //逻辑处理
            this.changePage(toPage);
        }
    },
    changePage:function(idx){
        if(idx!=this.currentPage && idx>0 && idx<=this.totalPage){
            // 触发父组件事件  pageChange会转换成小写pagechange
            this.$emit('change',{curPage:Number(idx)});
            }
    }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
        padding: 0;
        margin: 0;
}
/* .fl{
    float: left;
} */
.clearfix:after{
    display: block;
    content: '';
    clear: both;
}
.paging {
	vertical-align:middle;
    text-align: center;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 6px;
    padding: 8px 4px;
    color: #f0e6d2;
    font-size: 13px;
    box-sizing: border-box;
}
.page-size{
    line-height: 28px;
    padding: 0 6px;
    color: #ffd700;
    font-weight: 600;
    white-space: nowrap;
}
.page-list{
    display: inline-flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 4px;
    list-style: none;
    margin: 0;
    padding: 0;
    vertical-align: middle;
}
.page-jump{
    line-height: 28px;
    padding: 0 6px;
	vertical-align:middle;
    color: #f0e6d2;
    white-space: nowrap;
}
.page-jump .select{
    width: 56px;
    height: 26px;
    padding: 0 4px;
    border-radius: 4px;
    border: 1px solid #d4a574;
    background: #fff8f0;
    color: #3d3250;
    margin: 0 4px;
    text-align: center;
    font-size: 13px;
    box-sizing: border-box;
    cursor: pointer;
    outline: none;
}
.page-jump .select option {
    background: #fff8f0;
    color: #3d3250;
}
ul li{
    color: #f0e6d2;
    background: linear-gradient(180deg, #4a3f5c 0%, #3d3250 100%);
    border: 1px solid #5a4f6c;
    padding: 3px 10px;
    cursor: pointer;
    border-radius: 4px;
    font-size: 13px;
    min-width: 28px;
    text-align: center;
    box-sizing: border-box;
    user-select: none;
}
ul li:hover {
    background: linear-gradient(180deg, #5a4f6c 0%, #4a3f5c 100%);
    border-color: #d4a574;
}
ul>li.active{
    background: linear-gradient(180deg, #7b1fa2 0%, #4a148c 100%);
    color:#fff;
    border-color: #e0a0ff;
    font-weight: 600;
}
ul>li.active:hover {
    background: linear-gradient(180deg, #8e24aa 0%, #6a1b9a 100%);
}

/* ========== 移动端：上一页/下一页改为左右箭头 ========== */
@media (max-width: 768px) {
    .paging {
        padding: 8px 2px;
    }
    /* 移动端调整为紧凑显示 */
    .page-size,
    .page-jump {
        display: inline-flex;
        font-size: 12px;
    }
    .page-jump .select {
        width: 46px;
        height: 22px;
        font-size: 12px;
    }
    .page-list {
        gap: 6px;
    }
    .page-prev,
    .page-next {
        font-size: 0;
        min-width: 34px;
        padding: 4px 8px;
    }
    .page-prev::before {
        content: "‹";
        font-size: 18px;
        font-weight: 600;
        line-height: 1;
    }
    .page-next::before {
        content: "›";
        font-size: 18px;
        font-weight: 600;
        line-height: 1;
    }
    ul li {
        min-width: 32px;
        padding: 4px 10px;
    }
}
</style>